<template>
  <div class="form">
    <div class="form__header">
      <h3>Информация</h3>
    </div>
    <div class="form__body">
      <ul uk-accordion>
        <li>
          <a class="uk-accordion-title" href="#">Информация о занятиях</a>
          <div class="uk-accordion-content">
            <h5>Информация о занятиях для учеников</h5>

            <Input
              class="form__field"
              v-model="lesson_desc.zoom_ident"
              label="Идентификатор"
              type="text"
              id="zoom_ident"
            />
            <Input
              class="form__field"
              v-model="lesson_desc.zoom_link"
              label="Ссылка Zoom"
              type="text"
              id="zoom_link"
            />
            <Input
              class="form__field"
              v-model="lesson_desc.video_link"
              label="Запись занятия"
              type="text"
              id="video_link"
            />

            <div class="form__field">
              <span>Описание:</span>
              <textarea rows="5" v-model="lesson_desc.desc"></textarea>
            </div>
            <button
              type="button"
              class="header-menu__btn"
              @click="saveLessonAttention"
            >
              <i class="far fa-save"></i>
              Сохранить
            </button>
          </div>
        </li>
      </ul>
      <ClassMedia :class_id="classItem.id" :item="classItem" />
    </div>
  </div>
</template>

<script>
import ClassMedia from './ClassMedia.vue'
import Input from '../../../other/Input'
export default {
  components: { ClassMedia, Input },
  props: ['data', 'classItem'],
  inject: ['http'],
  data() {
    return {
      lesson_desc: {}
    }
  },
  methods: {
    saveLessonAttention() {
      let data = {
        id: this.$route.params.id,
        lesson_desc: this.lesson_desc,
      }
      this.http.post('onSaveLessonAttention', data).then(res => {
        this.$emit('update-lessons-info', this.lesson_desc)
        swal('Успешно!', 'Информация обновлена!', 'success')
      })
    },
  },
  created() {
    this.lesson_desc = _.cloneDeep(this.data)
  }
}
</script>
